import { useEffect } from "react";
import NotificationsSettingsTable from "./NotificationsSettingsTable";
import HeaderColumnData from "../../services/models/notificationsSettingsTableModels/headerColumnData.model";
import BodyColumnData from "./BodyColumnData.model";
import NotificationSettingsServices, {
  ApiUserNotificationTypeValue,
} from "../../services/NotificationSettingsServices";
import useOrganizations from "../../services/utils/custom hooks/useOrganizations";
import useMediumValues from "../../services/utils/custom hooks/Notifications/useMediumValues";
import useOrganizationNotificationMediumValues from "../../services/utils/custom hooks/Notifications/useOrganizationMediumValues";
import useNotificationTypes from "../../services/utils/custom hooks/Notifications/useNotificationTypes";
import useUserNotificationTypeValues from "../../services/utils/custom hooks/Notifications/useUserNotificationTypeValues";
import utils from "../../services/utils";

interface UserNotificationTypeTableProps {
  tableColumns: HeaderColumnData[];
  fetching: boolean;
  error: boolean;
  userNotificationTypesValues: ApiUserNotificationTypeValue[];
  tableBody: Array<BodyColumnData[]>;
  setTableBody: (data: Array<BodyColumnData[]>) => void;
  setTableColumns: (data: HeaderColumnData[]) => void;
}

function UserNotificationTypeTable({
  tableColumns,
  tableBody,
  setTableBody,
  setTableColumns,
}: UserNotificationTypeTableProps): JSX.Element {
  const { data: organizations, isLoading } = useOrganizations();
  const { data: mediumValues, isLoading: loadingMediums } = useMediumValues();
  const {
    data: organizationValues,
    isLoading: loadingOrganizationMediumValues,
  } = useOrganizationNotificationMediumValues();
  const { data: notificationTypes, isLoading: loadingNotificationTypes } =
    useNotificationTypes();
  const {
    data: userNotificationTypeValues,
    isLoading: loadingUserNotificationTypes,
  } = useUserNotificationTypeValues();

  const loading =
    isLoading ||
    loadingMediums ||
    loadingOrganizationMediumValues ||
    loadingNotificationTypes ||
    loadingUserNotificationTypes;

  const NotificationsSettingsData = new NotificationSettingsServices(
    organizations?.data ?? [],
    mediumValues?.data ?? [],
    organizationValues?.data ?? [],
    undefined,
    notificationTypes?.data ?? [],
    userNotificationTypeValues?.data ?? []
  );
  const dispatch = {};
  function handleSelectAll(id: string | number, value?: boolean) {
    setTableBody(
      NotificationsSettingsData.handleSelectAll(
        id,
        tableColumns,
        tableBody,
        dispatch,
        value
      ).tableBody
    );
    setTableColumns(
      NotificationsSettingsData.handleSelectAll(
        id,
        tableColumns,
        tableBody,
        dispatch,
        value
      ).tableColumn
    );
  }
  const personalSettingsValue = utils.getFilteredValues(tableBody);

  useEffect(() => {
    if (!loading) {
      NotificationsSettingsData.createPersonalNotificationTypeData();
      setTableColumns(
        NotificationsSettingsData.getPersonalNotificationTypeData().tableColumn
      );
      setTableBody(
        NotificationsSettingsData.getPersonalNotificationTypeData().tableBody
      );
    }
  }, [loading]);

  return (
    <NotificationsSettingsTable
      tableColumns={tableColumns}
      onSelectAll={handleSelectAll}
      tableBody={tableBody}
      setTableBody={setTableBody}
      isEnabled={personalSettingsValue}
    />
  );
}

export default UserNotificationTypeTable;
